module.exports = __webpack_public_path__ + "static/media/avatar-2.83b8e513.jpg";